module.exports = __webpack_public_path__ + "img/cicon2.273e9af4.png";